import Component from 'components/pages/PublicSurveys/PublicSurveys.qmee';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('earn-money-online');
export default buildPage(Component, {
  loggedInRedirect: '/earn',
  requiresAuthentication: false,
  metaData: {
    title: 'Surveys',
    description: 'Earn money online with Qmee surveys',
  },
});
